var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "introduction-process area"
  }, [_vm._m(0), _c("section", {
    staticClass: "introduction-process__main"
  }, [_c("a-timeline", {
    attrs: {
      mode: "alternate"
    }
  }, [_c("a-timeline-item", [_c("div", {
    staticClass: "line-dot",
    attrs: {
      slot: "dot"
    },
    slot: "dot"
  }, [_c("div", {
    staticClass: "line-dot-inside"
  })]), _c("a-tag", {
    attrs: {
      color: "#3870ff"
    }
  }, [_vm._v("1994年")]), _c("span", [_vm._v("杭州核新科技有限公司成立")])], 1), _c("a-timeline-item", {
    attrs: {
      color: "green"
    }
  }, [_c("div", {
    staticClass: "line-dot",
    attrs: {
      slot: "dot"
    },
    slot: "dot"
  }, [_c("div", {
    staticClass: "line-dot-inside"
  })]), _c("span", [_vm._v("推出国内首套证券网上行情交易系统")]), _c("a-tag", {
    attrs: {
      color: "#8facf7"
    }
  }, [_vm._v("1997年")])], 1), _c("a-timeline-item", [_c("div", {
    staticClass: "line-dot",
    attrs: {
      slot: "dot"
    },
    slot: "dot"
  }, [_c("div", {
    staticClass: "line-dot-inside"
  })]), _c("a-tag", {
    attrs: {
      color: "#8facf7"
    }
  }, [_vm._v("2001年")]), _c("span", [_vm._v("同花顺被国内90%+券商采用")])], 1), _c("a-timeline-item", [_c("div", {
    staticClass: "line-dot",
    attrs: {
      slot: "dot"
    },
    slot: "dot"
  }, [_c("div", {
    staticClass: "line-dot-inside"
  })]), _c("span", [_vm._v("成为唯一与三大运营商合作的手机金融信息服务商")]), _c("a-tag", {
    attrs: {
      color: "#8facf7"
    }
  }, [_vm._v("2003年")])], 1), _c("a-timeline-item", [_c("div", {
    staticClass: "line-dot",
    attrs: {
      slot: "dot"
    },
    slot: "dot"
  }, [_c("div", {
    staticClass: "line-dot-inside"
  })]), _c("a-tag", {
    attrs: {
      color: "#8facf7"
    }
  }, [_vm._v("2007年")]), _c("span", [_vm._v("同花顺股份成立")])], 1), _c("a-timeline-item", [_c("div", {
    staticClass: "line-dot",
    attrs: {
      slot: "dot"
    },
    slot: "dot"
  }, [_c("div", {
    staticClass: "line-dot-inside"
  })]), _c("span", [_vm._v("A股上市，成为互联网金融信息服务行业的第一家上市公司")]), _c("a-tag", {
    attrs: {
      color: "#8facf7"
    }
  }, [_vm._v("2009年")])], 1), _c("a-timeline-item", [_c("div", {
    staticClass: "line-dot",
    attrs: {
      slot: "dot"
    },
    slot: "dot"
  }, [_c("div", {
    staticClass: "line-dot-inside"
  })]), _c("a-tag", {
    attrs: {
      color: "#8facf7"
    }
  }, [_vm._v("2010年")]), _c("span", [_vm._v("注册用户突破1亿")])], 1), _c("a-timeline-item", [_c("div", {
    staticClass: "line-dot",
    attrs: {
      slot: "dot"
    },
    slot: "dot"
  }, [_c("div", {
    staticClass: "line-dot-inside"
  })]), _c("span", [_vm._v("首推金融垂直搜素“i问财”")]), _c("a-tag", {
    attrs: {
      color: "#8facf7"
    }
  }, [_vm._v("2012年")])], 1), _c("a-timeline-item", [_c("div", {
    staticClass: "line-dot",
    attrs: {
      slot: "dot"
    },
    slot: "dot"
  }, [_c("div", {
    staticClass: "line-dot-inside"
  })]), _c("a-tag", {
    attrs: {
      color: "#8facf7"
    }
  }, [_vm._v("2013年")]), _c("span", [_vm._v("同花顺客户端覆盖率第一")])], 1), _c("a-timeline-item", [_c("div", {
    staticClass: "line-dot",
    attrs: {
      slot: "dot"
    },
    slot: "dot"
  }, [_c("div", {
    staticClass: "line-dot-inside"
  })]), _c("span", [_vm._v("人工智能应用元年，同花顺智能科技有限公司成立")]), _c("a-tag", {
    attrs: {
      color: "#8facf7"
    }
  }, [_vm._v("2017年")])], 1), _c("a-timeline-item", [_c("div", {
    staticClass: "line-dot",
    attrs: {
      slot: "dot"
    },
    slot: "dot"
  }, [_c("div", {
    staticClass: "line-dot-inside"
  })]), _c("a-tag", {
    attrs: {
      color: "#3870ff"
    }
  }, [_vm._v("2020年")]), _c("span", [_vm._v("注册用户突破5亿")])], 1)], 1)], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "introduction-process__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("HISTORY")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("发展历程")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };